import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

export const RemoveDialog = ({ dialog, onDialogClose ,onConfirm}) => {
  return (
    <>
      <Dialog open={dialog} onClose={onDialogClose}>
        <div className="dialogStyling">
          <DialogTitle>Remove Item</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please confirm that the selected items are to be removed from the
              PO
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={onDialogClose}
              className="commonPOButtons"
              style={{
                marginRight: "8px",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onConfirm}
              className="commonPOButtons"
            >
              Confirm
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};
